import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';
import outTeamImg from '../../../images/webp/our-team.webp';

const OurTeam = () => {
    return (
        <div className="row  d-flex align-items-center">
            <div className="col-xl-4 col-md-5 text-md-start text-center pb-2">
                <h1 data-aos="fade-up" data-aos-duration="1500" className="fw-bolder">Our <span style={{ color: '#ff3465' }}>team</span></h1>
                <p data-aos="fade-up" data-aos-duration="2500" style={{textAlign: 'justify'}}>Morbi accumsan cras feugiat euismod suspendisse purus. Laoreet mi leo id pretium. Feugiat vitae posuere a lectus sit leo risus sapien. Viverra lacus faucibus vestibulum ut.</p>
                <Link data-aos="fade-up" data-aos-duration="3000" to="/" className="btn rounded-pill me-2 btn-global-style-solid">
                    See More <FontAwesomeIcon icon={faArrowRight} />
                </Link>
            </div>
            <div data-aos="fade-up" data-aos-duration="3000" className="col-xl-8 col-md-7">
                <img src={outTeamImg} className="w-100" alt="" />
            </div>
        </div>
    );
};

export default OurTeam;